import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';
export function SaveOnBoardingInfo (data) {
    return dispatch => {
        return axios.post(kinetik_api_url + '/save_boarding', data);
    }
}


// WEBPACK FOOTER //
// ./src/app/setup_onboarding/onBoarding.action.js